import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translation_en_gb from "./en-gb/translation.json";

export const initialiseTranslations = () => {
    i18n
        .use(initReactI18next)
        .init({
            resources: {
                "en": {
                    translation: translation_en_gb,
                }
            },
            lng: "en",
            fallbackLng: "en",
            interpolation: {
                escapeValue: false,
            }
        });
};